import { render, staticRenderFns } from "./CartPreviewItem.vue?vue&type=template&id=2f22d74f&scoped=true"
import script from "./CartPreviewItem.vue?vue&type=script&lang=ts"
export * from "./CartPreviewItem.vue?vue&type=script&lang=ts"
import style0 from "./CartPreviewItem.vue?vue&type=style&index=0&id=2f22d74f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f22d74f",
  null
  
)

export default component.exports